import { Target, Users } from 'lucide-react'

import FbButton from 'components/FbUI/FbButton'
import { ContactRequestJobFromCampaignModal } from 'components/Modals/ContactRequestJobFromCampaignModal'

interface CampaignContactsZeroStateProps {
  hasContactRequests: boolean
  campaignId: number
  isMultiType?: boolean
  onSwitchToTargets: () => void
  onContactRequested?: () => void
  variant: 'assign-targets' | 'request-contacts'
}

export function CampaignContactsZeroState({
  hasContactRequests,
  campaignId,
  isMultiType = false,
  onSwitchToTargets,
  onContactRequested,
  variant,
}: CampaignContactsZeroStateProps) {
  if (variant === 'assign-targets') {
    return (
      <div className="rounded-lg border border-line bg-surface p-12 text-center">
        <div className="mx-auto mb-4 flex size-14 items-center justify-center rounded-2xl bg-surface-alt">
          <Users className="size-7 text-fg-muted" />
        </div>
        <p className="mb-1 text-base text-fg">Assign targets first</p>
        <p className="mx-auto mb-4 max-w-sm text-sm text-fg-secondary">
          Before requesting contacts, you need to assign a target list to this
          campaign.
        </p>
        <FbButton
          type="button"
          size="sm"
          className="mx-auto gap-2"
          onClick={onSwitchToTargets}
        >
          <Target className="size-3.5" />
          Go to Targets
        </FbButton>
      </div>
    )
  }

  return (
    <div className="rounded-lg border border-line bg-surface p-12 text-center">
      <div className="mx-auto mb-4 flex size-14 items-center justify-center rounded-2xl bg-brand/5">
        <Users className="size-7 text-brand" />
      </div>
      <p className="mb-1 text-base text-fg">Request contacts</p>
      <p className="mx-auto mb-4 max-w-sm text-sm text-fg-secondary">
        This campaign has targets, but contacts have not been requested yet.
      </p>
      {hasContactRequests ? (
        <div className="flex justify-center">
          <ContactRequestJobFromCampaignModal
            campaignId={campaignId}
            isMultiType={isMultiType}
            buttonText="Request Contacts"
            onContactRequested={onContactRequested}
          />
        </div>
      ) : (
        <p className="text-sm text-fg-secondary">
          Contact requests are not available for this campaign type.
        </p>
      )}
    </div>
  )
}
